module.exports = __webpack_public_path__ + "img/jtj_tbt776_1993.prt.686ea544.jpg";